import { Controller } from "@hotwired/stimulus"

// This controller is used to manage remove only filters.
export default class extends Controller {
  static get targets() {
    return ["selectedOption"]
  }

  static get values() {
    return {
      name: String,
      selected: { type: Array, default: [] },
      optionsSize: Number,
      context: { type: String, default: "" }
    }
  }

  connect() {
    this.render()
  }

  remove(event) {
    let optionAsString = event.params.option.toString();
    this.selectedValue = this.selectedValue.filter(value => value !== optionAsString)
    this.render()
    this.dispatchFilterEvent()
  }

  clear() {
    let anyChanges = this.selectedValue.length > 0
    this.selectedValue = []
    this.render()
    if (anyChanges) {
      this.dispatchFilterEvent()
    }
  }

  render() {
    this.showSelectedFilters()
  }

  showSelectedFilters() {
    this.selectedOptionTargets.forEach(selectedOption => {
      if (this.selectedValue.includes(selectedOption.dataset.value)) {
        selectedOption.classList.remove("d-none")
      } else {
        selectedOption.classList.add("d-none")
      }
    })
  }

  dispatchFilterEvent() {
    // Create event detail object
    const detail = {
      name: this.nameValue,
      values: this.selectedValue
    }

    // Only add context if it's explicitly set (backwards compatibility)
    if (this.contextValue) {
      detail.context = this.contextValue
    }

    this.dispatch("filter", { detail })
  }
}
